export default "__VITE_ASSET__6y_XKaQs__"